import { FC } from "react";
import { Badge, Flex, RadioGroup, Text } from "@chakra-ui/react";

import { MEDICAL_FIELD_CHOICE } from "@shared/models";
import { FONT_WEIGHT } from "@assets/theme/foundations/textStyle";

export interface FieldValueOption {
  choice: MEDICAL_FIELD_CHOICE;
  title: string;
  source: string | null;
  text: string | null;
  flagReason?: string | null;
}

interface ChooseFieldValueOptionProps {
  option: FieldValueOption;
  selected: boolean;
}

const ChooseFieldValueOption: FC<ChooseFieldValueOptionProps> = ({
  option: { choice, title, source, text, flagReason },
  selected,
}) => (
  <RadioGroup.Item
    value={choice}
    alignItems="flex-start"
    gap="14px"
    w="100%"
    px="17px"
    py="15px"
    borderRadius="10px"
    border={selected ? "2px solid" : "1px solid"}
    borderColor={selected ? "brand.primary" : "gray.200"}
    bg={selected ? "brand.primary/5" : "white"}
    cursor="pointer"
    _focusVisible={{ outline: "2px solid", outlineColor: "brand.primary/40" }}
  >
    <RadioGroup.ItemHiddenInput />
    <Flex
      align="center"
      justify="center"
      flexShrink={0}
      boxSize="18px"
      mt="2px"
      borderRadius="full"
      border="2px solid"
      borderColor={selected ? "brand.primary" : "grey.10"}
    >
      {selected && <Flex boxSize="8px" borderRadius="full" bg="brand.primary" />}
    </Flex>
    <Flex direction="column" gap="6px" minW={0}>
      <Flex wrap="wrap" align="center" gap={2}>
        <RadioGroup.ItemText fontSize="15px" fontWeight={FONT_WEIGHT.HEAVY} color="brand.modalHeaderText">
          {title}
        </RadioGroup.ItemText>
        {source && (
          <Text fontSize="12px" color="brand.emptyStateText">
            {source}
          </Text>
        )}
        {flagReason && (
          <Badge bg="score.midBg" color="score.midText" fontWeight={FONT_WEIGHT.BOLD} letterSpacing="0.06em">
            LOW CONFIDENCE
          </Badge>
        )}
      </Flex>
      {text && (
        <Text fontSize="13px" lineHeight={1.55} color="brand.textSecondary" whiteSpace="pre-line">
          {text}
        </Text>
      )}
      {flagReason && (
        <Text fontSize="12px" lineHeight={1.5} color="score.midText">
          {flagReason} The flag stays on the field if you pick this.
        </Text>
      )}
    </Flex>
  </RadioGroup.Item>
);

export default ChooseFieldValueOption;
